import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import AumLine from './AumLine'



export default function OnBoardingLineChart() {
    const { typography, palette } = useTheme()

    return (
        <Box sx={{ padding: '25px 30px 10px 30px', flexDirection: 'column', display: 'flex', gap: '20px', height: '100%', width: '100%', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='h2' >AUM Distribution</Typography>
                <Typography variant='body_500' color={palette.grey[700]} >Last 4 Months</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', justifyContent: 'space-between', height: '100%' }}>
                <AumLine />
                <AumLine />
                <AumLine />
                <AumLine />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '14px', alignItems: 'center' }}>
                <Typography variant='body_400' sx={{ textWrap: 'nowrap' }} color={'transparent'}>May 2024</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
                    <Typography variant='body_400' color={palette.text.primary}>1</Typography>
                    <Typography variant='body_400' color={palette.text.primary}>2</Typography>
                    <Typography variant='body_400' color={palette.text.primary}>3</Typography>
                    <Typography variant='body_400' color={palette.text.primary}>4</Typography>
                    <Typography variant='body_400' color={palette.text.primary}>5</Typography>
                </Box>
            </Box>


        </Box>
    )
}